// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Uh7WZ","section":"Home_section__ejtmr","rowA":"Home_rowA__jdirL","rowA2":"Home_rowA2__H661q","footer":"Home_footer__JlTvt"};